import { SVGProps } from "react";
const XCloseNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.797 29.797"
    width={35.441}
    height={35.441}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M27.676 2.121 2.121 27.676m0-25.555 25.555 25.555"
    />
  </svg>
);
export default XCloseNew;
